import { SlackOutlined } from '@ant-design/icons'
import { ProviderAuthenticationClient } from '~/plugins/data-connector/authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderSlackCommon } from '../common'

export const ProviderSlackClient: ProviderClient = {
  key: ProviderSlackCommon.key,
  authentication: ProviderAuthenticationClient.Oauth2(
    ProviderSlackCommon.authentication,
  ),
  description: {
    label: 'Slack',
    icon: <SlackOutlined />,
    triggers: [
      {
        key: 'newMessage',
        label: 'New message',
        input: [],
        output: [
          { key: 'teamId' },
          { key: 'channelId' },
          { key: 'messageId' },
          { key: 'message' },
        ],
      },
    ],
    actions: [
      {
        key: 'sendMessage',
        label: 'Send message',
        input: [
          {
            key: 'channelId',
          },
          {
            key: 'message',
          },
        ],
        output: [
          {
            key: 'id',
          },
        ],
      },
      {
        key: 'findManyChannelsByServer',
        label: 'List channels',
        input: [],
        output: [
          {
            key: 'channels',
            type: 'array_objects',
            properties: [{ key: 'id' }, { key: 'name' }],
          },
        ],
      },
    ],
  },
}
